export default __webpack_public_path__ + "static/media/email_broadcast.e1a4d92c.png";